// Dotchat — thin wrapper around the Web Notifications API so the Notifications
// Hub can surface in-app events to the browser/OS.

export const isBrowserNotificationSupported = () =>
  typeof window !== 'undefined' && 'Notification' in window;

export const browserNotificationPermission = () =>
  isBrowserNotificationSupported() ? Notification.permission : 'denied';

export const requestBrowserNotificationPermission = async () => {
  if (!isBrowserNotificationSupported()) return 'denied';
  try {
    return await Notification.requestPermission();
  } catch {
    return browserNotificationPermission();
  }
};

// Fire an OS/browser notification. Returns the Notification instance or null.
export const showBrowserNotification = (title, { body, tag, icon } = {}) => {
  if (
    !isBrowserNotificationSupported() ||
    Notification.permission !== 'granted'
  ) {
    return null;
  }
  try {
    return new Notification(title, {
      body,
      tag,
      icon: icon || '/favicon-32x32.png',
    });
  } catch {
    return null;
  }
};
